// Zazzle Create-A-Product API Configuration
//
// To set up your Zazzle integration:
// 1. Create a Zazzle account at https://www.zazzle.com
// 2. Join Associates Program at https://www.zazzle.com/my/associate/associate
// 3. Accept API Terms at https://www.zazzle.com/my/associate/create_a_product_api_signup
// 4. Declare your domain in API settings
// 5. Create product templates for each product type and note the 18-digit Product IDs
// 6. Replace the placeholder IDs below with your actual IDs

export const ZAZZLE_CONFIG = {
  // Set to false to hide the "Create Merch" button
  enabled: false,

  // Your 18-digit Zazzle account ID (found in your account settings)
  accountId: '238036014935782078',

  // Your 18-digit Associate ID for commission tracking
  associateId: '238036014935782078',

  // Product template IDs and image parameter names
  // - id: 18-digit Product ID from the template URL
  // - imageParam: The URL parameter name you set for the image in your template
  templates: {
    tshirt: { id: '256626090444373144', imageParam: 'pepeimage' },
    mug: { id: '256394982447399044', imageParam: 'pepeimage' },
    socks: { id: '256526141369552998', imageParam: 'pepeimage' },
  },

  // Tracking code for analytics
  trackingCode: 'pepegallery',
};

export type ZazzleProductType = 'tshirt' | 'mug' | 'socks';

export const ZAZZLE_PRODUCTS: { type: ZazzleProductType; label: string; emoji: string }[] = [
  { type: 'tshirt', label: 'T-Shirt', emoji: '\uD83D\uDC55' },
  { type: 'mug', label: 'Mug', emoji: '\u2615' },
  { type: 'socks', label: 'Socks', emoji: '\uD83E\uDDE6' },
];


// https://www.zazzle.com/shirt-256626090444373144
// https://www.zazzle.com/cobbee_mug-256394982447399044
// https://www.zazzle.com/cozy_socks-256526141369552998